import { render, staticRenderFns } from "./UserSettingsPage.vue?vue&type=template&id=7e8eaecc"
import script from "./UserSettingsPage.vue?vue&type=script&lang=js"
export * from "./UserSettingsPage.vue?vue&type=script&lang=js"
import style0 from "./UserSettingsPage.vue?vue&type=style&index=0&id=7e8eaecc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports